<template>
  <div class="pie-wrapper" :style="pieWrapperDimension">
    <div class="pie-background" :style="pieBackgroundStyle"></div>
    <div class="pie-slice-1 hold" :style="holdStyle">
      <div class="pie" :style="firstPieStyle"></div>
    </div>
    <div class="pie-slice-2 hold" :style="holdStyle">
      <div class="pie" :style="secondPieStyle"></div>
    </div>
  </div>
</template>

<script>
/**
 * This shows a pie. completedPercent part is shown in white background. Rest is shown as active color
 * props:
 *  - completedPercent
 */
export default {
  name: 'TimelinePie',
  props: {
    completedPercent: Number,
    size: {
      default: 14,
      type: Number
    }
  },
  computed: {
    completedArcDegree() {
      const degPercentRatio = 360 / 100
      return degPercentRatio * this.completedPercent
    },
    firstPieStyle() {
      const rotateBy = this.completedArcDegree > 180 ? 180 : this.completedArcDegree
      return {
        transform: `rotate(${rotateBy}deg)`,
        ...this.pieStyle
      }
    },
    secondPieStyle() {
      const rotateBy = this.completedArcDegree > 180 ? this.completedArcDegree - 180 : 0
      return {
        transform: `rotate(${rotateBy}deg)`,
        ...this.pieStyle
      }
    },
    pieWrapperDimension() {
      return {
        ...this.dimension(this.size + 2, this.size + 2)
      }
    },
    pieBackgroundStyle() {
      return {
        ...this.pieWrapperDimension,
        borderRadius: `${this.size / 2 + 1}px`
      }
    },
    pieStyle() {
      return {
        ...this.dimension(this.size, this.size),
        borderRadius: `${this.size / 2 + 1}px`,
        clip: `rect(0px, ${this.size / 2}px, ${this.size}px, 0px)`
      }
    },
    holdStyle() {
      return {
        ...this.dimension(this.size, this.size),
        borderRadius: `${this.size / 2 + 2}px`,
        clip: `rect(0px, ${this.size}px, ${this.size}px, ${this.size / 2}px)`
      }
    }
  },
  methods: {
    dimension(width, height) {
      return {
        width: `${width}px`,
        height: `${height}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
.pie-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pie-background {
  position: absolute;
  background-color: $active;
}

.pie {
  position: absolute;
}

.hold {
  position: absolute;
}

.pie-slice-1 .pie {
  background-color: white;
}

.pie-slice-2 {
  transform: rotate(180deg);
}

.pie-slice-2 .pie {
  background-color: white;
}
</style>
